export const locale = {
  lang: 'en',
  data: {
    SHORTCUT: {
      ADD: {
        NEW_INVOICE: 'Invoice',
        NEW_CLIENT: 'Client',
        NEW_COMPANY: 'Company',
        MASSIVE_COMPANY_IMPORT: 'Massive import companies',
      },
      EXPORT: {
        AUCTION_FUTURE: 'Export future auctions',
        AUCTION_PROGRESS: 'Export auction in progress',
        AUCTION_AWARDED: 'Export auction awarded',
      },
      SNACKBAR: {
        CLIENT_ADDED: 'Client added successfully!',
        INVOICE_ADDED: 'Invoice added successfully!',
        COMPANY_ADDED: 'Company added successfully!',
        MASSIVE_COMPANY_ADDED: 'Successful company import. Companies will soon be available on the portal.',
      },
      WALLET_BALANCE: 'Wallet balance',
      EXPORT_CSV: 'Export as CSV',
      EXPORT_XLS: 'Export as XLS',
    },
  },
};
